var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28571 6.71429H1.71429C1.5119 6.71429 1.34226 6.64583 1.20536 6.50893C1.06845 6.37202 1 6.20238 1 6C1 5.79762 1.06845 5.62798 1.20536 5.49107C1.34226 5.35417 1.5119 5.28571 1.71429 5.28571H5.28571V1.71429C5.28571 1.5119 5.35417 1.34226 5.49107 1.20536C5.62798 1.06845 5.79762 1 6 1C6.20238 1 6.37202 1.06845 6.50893 1.20536C6.64583 1.34226 6.71429 1.5119 6.71429 1.71429V5.28571H10.2857C10.4881 5.28571 10.6577 5.35417 10.7946 5.49107C10.9315 5.62798 11 5.79762 11 6C11 6.20238 10.9315 6.37202 10.7946 6.50893C10.6577 6.64583 10.4881 6.71429 10.2857 6.71429H6.71429V10.2857C6.71429 10.4881 6.64583 10.6577 6.50893 10.7946C6.37202 10.9315 6.20238 11 6 11C5.79762 11 5.62798 10.9315 5.49107 10.7946C5.35417 10.6577 5.28571 10.4881 5.28571 10.2857V6.71429Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusS);
export default __webpack_public_path__ + "static/media/plus-s.f03001ac9c6c5085588f96b3933c2e50.svg";
export { ForwardRef as ReactComponent };